<!--  -->
<template>
  <div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="name"
        label="目标名称"
        width="500"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="choosefenlei(scope.row)"
          >选择
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      style="margin-top:20px"
      :total="total"
      :current-page="obj.page"
      :page-size="10"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { videoCategorylist } from '@/api/sourceminiprogram.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      obj: {
        page: 1,
        page_size: 10
      },
      total: null,
      tableData: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.list()
    },
    async list() {
      const data = await videoCategorylist(this.obj)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    fetchPageSize(e) {
      console.log('111')
      this.obj.page_size = e
      this.obj.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.obj.page = e
      this.list()
    },
    choosefenlei(item) {
      this.$emit('targetclass', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>